import { useSelector } from "react-redux";
import { CONTENT_STEP } from "./constant";
import { selectContentStep } from "./store/appSlice";
import { PageGetResult } from "./views/GetResult/PageGetResult";
import { PageSelectDistrict } from "./views/SelectDistrict/PageSelectDistrict";
import { Content, WrapContent } from "./views/style/styled";

function App() {
  const step = useSelector(selectContentStep);

  return (
    <WrapContent>
      <Content id="content">
        {step === CONTENT_STEP.SELECT_DISTRICT && <PageSelectDistrict />}
        {step === CONTENT_STEP.GET_RESULT && <PageGetResult />}
      </Content>
    </WrapContent>
  );
}

export default App;
